import React from 'react';
import { Box } from 'vindi-ds-components';
import styles from './styles';

function HeaderNavigation({ children }) {
  return <Box css={styles.navigation}>{children}</Box>;
}

export default HeaderNavigation;
